import React from 'react'
import logo from '@assets/images/logo.png'
import { useForm, Controller } from 'react-hook-form'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '@components/index'
import { useYupValidation } from '@hooks/index'
import { IAuthCreatePassword } from '@interfaces/index'
import { AuthService, errorHandler } from '@services/index'
import { toast } from 'react-toastify'
import createPasswordSchema from '@yupSchemas/auth/createPasswordSchema'

export default function CreatePassword(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const params = useParams()

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthCreatePassword>({
        resolver: useYupValidation(createPasswordSchema),
    })

    const token = new URLSearchParams(useLocation().search).get('token')
    const id = params.id

    async function createPassword(values: IAuthCreatePassword): Promise<void> {
        setIsLoading(true)
        try {
            if (!token || !id) {
                throw new Error('Erro ao criar a senha!')
            }
            await AuthService.createPassword(values, token, Number(id))
            toast('Senha criada com sucesso!', { type: 'success' })
            navigate('/')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="box-reset-password">
            <div className="reset-password__backgound">
                <div className="reset-password__content">
                    <div className="reset-password__images">
                        <img src={logo} alt="Logo CNA construtora" className="reset-password__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Crie sua senha</h4>
                    <form id="reset-password__form" onSubmit={handleSubmit(createPassword)}>
                        <div className="reset-password__inputs">
                            <Controller
                                name="password"
                                defaultValue={''}
                                control={control}
                                render={({ field: { value, onChange } }) => {
                                    return <InputForm sx={{ width: '100%' }} size='small' placeholder="Senha" label="Senha" type="password" name="password" value={value} onChange={onChange} />
                                }}
                            />
                            <ErrorForm error={errors.password?.message} />

                            <Controller
                                name="passwordConf"
                                control={control}
                                defaultValue={''}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <InputForm
                                            type="password"
                                            placeholder="Confirmação da Senha"
                                            label="Confirmação da Senha"
                                            name="passwordConf"
                                            value={value}
                                            sx={{ width: '100%' }}
                                            onChange={onChange}
                                            size='small'
                                        />
                                    )
                                }}
                            />
                            <ErrorForm error={errors.passwordConf?.message} />
                        </div>
                        <div className="box-button-reset-password">
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                                <Button isLoading={isLoading} type={'submit'} placeholder="Criar Senha" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
